"use strict";

exports.__esModule = true;
exports.ElevateSettingsMenu = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _reactRouterDom = require("react-router-dom");
var _Translator = require("../../Core/Translator");
var _ProfileDialog = require("../../Profile/ProfileDialog");
var _UiPreferencesDialog = require("../../UiPreferences/UiPreferencesDialog");
var _UiPreferencesContext = require("../../UiPreferences/UiPreferencesContext");
var _System = require("../../../System");
var _Locale = require("./Locale");
var _LogoutMenuItem = require("./LogoutMenuItem");
var _EnvContext = require("../../Env/EnvContext");
var _HasAccess = require("../../Auth/Access/HasAccess");
var _Theme = require("../../Theme");
var _reactIntl = require("react-intl");
var _getPartnerUrls = _interopRequireDefault(require("./getPartnerUrls"));
var _switchPlant = require("../../App/AppNavbar/switchPlant");
var _Auth = require("../../Auth");
var _App = require("../../App");
var _API = require("../../API");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var SettingsMenuContainer = _styledComponents["default"].div.attrs({
  className: "settings-menu-container"
}).withConfig({
  displayName: "ElevateSettingsMenu__SettingsMenuContainer",
  componentId: "sc-60d8m9-0"
})([""]);
var MenuWrapper = _styledComponents["default"].div.attrs({
  className: "menu-wrapper"
}).withConfig({
  displayName: "ElevateSettingsMenu__MenuWrapper",
  componentId: "sc-60d8m9-1"
})([".", "{max-height:unset !important;}"], _core.Classes.MENU);
var Settings = (0, _styledComponents["default"])(_core.Button).attrs({
  className: "settings-button",
  "data-testid": "settings-icon"
}).withConfig({
  displayName: "ElevateSettingsMenu__Settings",
  componentId: "sc-60d8m9-2"
})(["&.", "{border:none;&:hover{background-color:#ffffff24;}&:focus{outline:unset;background-color:#ffffff24;}&:active{background-color:#ffffff24;}}&.", "{background-color:#ffffff24;}"], _core.Classes.BUTTON, _core.Classes.ACTIVE);
var ElevateSettingsMenu = exports.ElevateSettingsMenu = function ElevateSettingsMenu() {
  var _useState = (0, _react.useState)(false),
    isProfileDialogOpen = _useState[0],
    setProfileDialogOpen = _useState[1];
  var _useState2 = (0, _react.useState)(false),
    isUiPreferencesOpen = _useState2[0],
    setUiPreferencesOpen = _useState2[1];
  var _React$useContext = _react["default"].useContext(_API.RestAPIContext),
    plantName = _React$useContext.plantName;
  var _React$useContext2 = _react["default"].useContext(_Auth.AuthContext),
    permissions = _React$useContext2.permissions;
  var _useContext = (0, _react.useContext)(_App.NavbarSettingsMenuContext),
    setIsSwitchPlantOpen = _useContext.setIsSwitchPlantOpen;
  // Only where the environment lets users pick their interface
  // (ENABLE_UI_PREFERENCES); production sets no such flag.
  var _useContext2 = (0, _react.useContext)(_UiPreferencesContext.UiPreferencesContext),
    canChooseInterface = _useContext2.enabled;
  var _useContext3 = (0, _react.useContext)(_Translator.TranslatorContext),
    translate = _useContext3.translate;
  // $FlowFixMe
  var env = (0, _react.useContext)(_EnvContext.EnvContext);
  var administrativePlantName = env.administrativePlantName;
  var navigate = (0, _reactRouterDom.useNavigate)();
  var isAdministrativePlant = administrativePlantName === plantName;
  var configurationApps = [{
    id: "SettingsMenu.PlantTwin",
    screenName: "PlantTwin",
    name: "Plant Twin",
    accessRight: "PLANT_TWIN"
  }, {
    id: "SettingsMenu.Devices",
    screenName: "DeviceList",
    name: "Devices"
  }, {
    id: "SettingsMenu.Users",
    screenName: "UserList",
    name: "Users",
    switchPlantLanding: true
  }, {
    id: "SettingsMenu.AdminConfiguration",
    screenName: "AdminConfiguration",
    name: "Admin Configuration"
  }];
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(SettingsMenuContainer, null, /*#__PURE__*/_react["default"].createElement(_core.Popover, {
    className: (0, _Theme.val)("NavbarBackgroundTheme"),
    position: _core.Position.BOTTOM_RIGHT,
    canEscapeKeyClose: true,
    enforceFocus: false,
    shouldDismissPopover: false,
    content: /*#__PURE__*/_react["default"].createElement(MenuWrapper, null, /*#__PURE__*/_react["default"].createElement(_core.Menu, null, configurationApps.map(function (app) {
      return (app.switchPlantLanding || !isAdministrativePlant) && /*#__PURE__*/_react["default"].createElement(_HasAccess.HasAccess, {
        key: app.screenName,
        permission: app.accessRight || undefined,
        featureFlag: app.featureFlag || undefined
      }, /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
        onClick: function onClick() {
          navigate((0, _System.getScreenPath)(app.screenName).replace("/:id?", ""));
        },
        text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: app.id,
          defaultMessage: app.name
        })
      }));
    }), /*#__PURE__*/_react["default"].createElement(_core.MenuDivider, null), /*#__PURE__*/_react["default"].createElement(_Locale.LocaleMenuItem, null), /*#__PURE__*/_react["default"].createElement(_core.MenuDivider, null), /*#__PURE__*/_react["default"].createElement(_HasAccess.HasAccess, {
      permission: "VIEW_DOCUMENTATION"
    }, /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
      text: translate("SettingsMenu.Documentation", "Documentation"),
      href: (0, _getPartnerUrls["default"])(env, "documentationUrl"),
      target: "_blank",
      rel: "noopener noreferrer"
    })), /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
      text: translate("SettingsMenu.Support", "Contact Support"),
      href: (0, _getPartnerUrls["default"])(env, "customerSupportUrl"),
      target: "_blank",
      rel: "noopener noreferrer"
    }), /*#__PURE__*/_react["default"].createElement(_core.MenuDivider, null), /*#__PURE__*/_react["default"].createElement(_HasAccess.HasAccess, {
      permission: "EDIT_MESSAGES"
    }, /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
      text: translate("SettingsMenu.UserNotifications", "Messages"),
      onClick: function onClick() {
        navigate((0, _System.getScreenPath)("UserNotifications").replace("/:id?", ""));
      }
    }), /*#__PURE__*/_react["default"].createElement(_core.MenuDivider, null)), (0, _switchPlant.shouldEnableSwitchPlant)(permissions) ? /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
      text: translate("SettingsMenu.switchPlant.title", "Switch Plant"),
      onClick: function onClick() {
        if (setIsSwitchPlantOpen) {
          setIsSwitchPlantOpen(true);
        }
      },
      "data-testid": "ElevateSettingsMenu.VimanaUser.Item.SwitchPlant"
    }) : null, /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
      text: translate("SettingsMenu.Profile", "Profile"),
      onClick: function onClick() {
        return setProfileDialogOpen(true);
      }
    }), canChooseInterface && /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
      text: translate("SettingsMenu.Interface", "Interface"),
      onClick: function onClick() {
        return setUiPreferencesOpen(true);
      },
      "data-testid": "ElevateSettingsMenu.Item.Interface"
    }), /*#__PURE__*/_react["default"].createElement(_LogoutMenuItem.LogoutMenuItem, null)))
  }, /*#__PURE__*/_react["default"].createElement(Settings, {
    icon: /*#__PURE__*/_react["default"].createElement(_core.Icon, {
      icon: _icons.IconNames.COG
    })
  })), /*#__PURE__*/_react["default"].createElement(_ProfileDialog.ProfileDialog, {
    placeholder: translate("SettingsMenu.Profile", "Profile"),
    isOpen: isProfileDialogOpen,
    onClose: function onClose() {
      return setProfileDialogOpen(false);
    }
  }), canChooseInterface && /*#__PURE__*/_react["default"].createElement(_UiPreferencesDialog.UiPreferencesDialog, {
    isOpen: isUiPreferencesOpen,
    onClose: function onClose() {
      return setUiPreferencesOpen(false);
    }
  })));
};